/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-sub-section-ntlm';
const prefix = `${moduleName}.${componentName}`;

export const ntlmLabel = `${prefix}.ntlmLabel`;
export const ntlmStatusLabel = `${prefix}.ntlmStatusLabel`;
export const detectedLabel = `${prefix}.detectedLabel`;
export const undetectedLabel = `${prefix}.undetectedLabel`;

export const ENGLISH = {
    [ntlmLabel]: 'NTLM',
    [ntlmStatusLabel]: 'NTLM Status',
    [detectedLabel]: 'Detected',
    [undetectedLabel]: 'Undetected',
};
